import { render, staticRenderFns } from "./GroupResultAG.vue?vue&type=template&id=4cf226c2&scoped=true"
import script from "./GroupResultAG.vue?vue&type=script&lang=js"
export * from "./GroupResultAG.vue?vue&type=script&lang=js"
import style0 from "./GroupResultAG.vue?vue&type=style&index=0&id=4cf226c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf226c2",
  null
  
)

export default component.exports